import Editor from 'components/playbook/components/Editor'


const BotFollowUp = ({
  showFollowUpPrompt,
  questionIndex,
  response,
  onResponseChange,
}) =>
  <div>
    {showFollowUpPrompt && (
       <div>
         <strong>Enter the Bot’s Follow Up Response</strong>
         <p>
           Your lead has answered Question {questionIndex + 1}. How do you want the bot to
           respond?
         </p>
       </div>
    )}
    <Editor
      value={response}
      onChange={onResponseChange}
      placeholder="Add your follow up text"
      popoverAnchorBottom={true}
    />
  </div>

export default BotFollowUp



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/AnswerModal/botFollowUp.js